import { MultiSelect as GammaMultiSelect } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type MultiSelectProps = React.ComponentProps<typeof GammaMultiSelect>

type Props = Omit<MultiSelectProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const MultiSelect = ({ missingLabel, ...props }: Props) => (
  <GammaMultiSelect
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default MultiSelect
